import React, { Component, createRef } from 'react';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';
import { tab } from '@testing-library/user-event/dist/tab.js';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { printFunction } from '../../components/print/printTemplate.js';

class StockLedgerReport extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            companyName: '',
            totalProduceedQty: 0,
            totalIssuedQty: 0,
            closingBalance: 0,
            itemDropdownList: [],
            partyDropdownList: [],
            batchDropdownList: [],
            allTransactionDropdownList: [],
            itemsForStockLedgerList: [],
            stockLedgerReportList: [],
            stockLedgerReportBatchStock: [],
            isLoading: false,
            tableStatus: "",
            filterDetails: {
                itemId: "",
                startDate: "",
                endingDate: "",
                search: "stockRegister",
                partyId: "",
                batchNo: "",
                allTransaction: "",
                partyName: "",
                searchBy: "partyName",

            },
            searchList: [
                { search: "Stock Register", value: "stockRegister" },
                { search: "Batch Stock", value: "batchStock" },
            ],
            searchByList: [
                { search: "Party Name", value: "partyName" },
                { search: "Batch No.", value: "batchNo" },
            ],
            validationRules: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endingDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endingDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
        this.getAllItem();
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    getAllItem = () => {
        this.commonServices.getAllItem().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.ItemName,
                    value: item._id,
                }));
                this.setState({ itemDropdownList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllStockLedgerReport = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate();
        if (isAllFieldsValidate) {
            this.setState({ tableStatus: "Loading...", isLoading: true }, () => {
                let request = this.state.filterDetails
                this.despatchServices.getAllStockLedgerReport(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        const totalProduceedQty = response.responseData.reduce((sum, item) => sum + item.produceedQty, 0);
                        const totalIssuedQty = response.responseData.reduce((sum, item) => sum + item.issuedQty, 0);
                        const totalfreeQty = response.responseData.reduce((sum, item) => sum + item.isFreeQty, 0);
                        const closingBalance = totalProduceedQty - (totalIssuedQty + totalfreeQty);
                        const seenParties = new Set();
                        const dropdownDataForParty = response.responseData
                            .filter((x) => {
                                if (seenParties.has(x.partyName)) {
                                    return false;
                                }
                                seenParties.add(x.partyName);
                                return true;
                            })
                            .map((x) => ({
                                label: x.partyName,
                                value: x.partyId
                            }));

                        const seenBatches = new Set();
                        const dropdownDataForBatch = response.responseData
                            .filter((x) => {
                                if (seenBatches.has(x.batchNo)) {
                                    return false;
                                }
                                seenBatches.add(x.batchNo);
                                return true;
                            })
                            .map((x, index) => ({
                                label: x.batchNo,
                                value: index + 1
                            }));
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({
                            stockLedgerReportList: response.responseData,
                            isLoading: false,
                            totalProduceedQty: totalProduceedQty,
                            totalIssuedQty: totalIssuedQty + totalfreeQty,
                            closingBalance: closingBalance,
                            partyDropdownList: this.state.filterDetails.searchBy === 'partyName' ? dropdownDataForParty : dropdownDataForBatch
                        }, () => {
                            if (this.state.filterDetails.searchBy === 'partyName') {
                                if (this.state.filterDetails.partyName !== '') {
                                    let list = this.state.stockLedgerReportList
                                    list = list.filter(x => x.partyName === this.state.filterDetails.partyName)
                                    this.setState({ stockLedgerReportList: list })
                                }
                            } else if (this.state.filterDetails.searchBy === 'batchNo') {
                                if (this.state.filterDetails.batchNo !== '') {
                                    let list = this.state.stockLedgerReportList
                                    list = list.filter(x => x.batchNo === this.state.filterDetails.batchNo)
                                    this.setState({ stockLedgerReportList: list })
                                }
                            }
                        })
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    getAllStockLedgerReportBatchStock = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate();
        if (isAllFieldsValidate) {
            this.setState({ tableStatus: "Loading...", isLoading: true }, () => {
                let request = this.state.filterDetails
                this.despatchServices.getAllStockLedgerReportBatchStock(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ stockLedgerReportBatchStock: response.responseData, isLoading: false })
                    } else {
                        this.setState({ tableStatus: "", isLoading: false })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };


    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let filterDetails = this.state.filterDetails
        filterDetails.itemId = ""
        filterDetails.startDate = ""
        filterDetails.endingDate = ""
        filterDetails.search = "stockRegister"
        filterDetails.partyId = ""
        filterDetails.batchNo = ""
        filterDetails.allTransaction = ""
        filterDetails.searchBy = "partyName"
        this.setState({ filterDetails: filterDetails, validState: validState, stockLedgerReportList: [], stockLedgerReportBatchStock: [], })
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details })

    };

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.filterDetails
        details[drpIdentity] = selected.value
        if (drpIdentity === 'batchNo') {
            details.batchNo = selected.label
        }
        if (drpIdentity === 'partyId') {
            details.partyName = selected.label
        }
        this.setState({ filterDetails: details }, () => {
            if (drpIdentity === 'partyId' || drpIdentity === 'batchNo') {
                this.getAllStockLedgerReport()
            }
        })
    }

    handleDropdownChange = (e, name) => {
        const value = e.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details }, () => {
            if (name === 'search') {
                this.setState({ isLoading: false, tableStatus: "" })
            }
            if (name === 'searchBy') {
                this.getAllStockLedgerReport()
            }
        });
    };

    getAllReports = () => {
        if (this.state.filterDetails.search === 'stockRegister') {
            this.getAllStockLedgerReport()
        } else {
            this.getAllStockLedgerReportBatchStock()
        }
    }

    render() {
        return (
            <div className='stockLedgerReport-page'>
                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="input-grp min-w-[30%]">
                        <label>Item Name</label>
                        <MultiSelectDropdown
                            drpIdentity="itemId"
                            options={this.state.itemDropdownList}
                            className={` ${this.state.validState?.error?.itemId ? "errorInput" : ""}`}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                this.setFilterParameters(selected, "itemId", 'filterDetails')
                            }
                            allowSelectAll={false}
                            value={this.state.itemDropdownList.filter(
                                (item) =>
                                    item.value === this.state.filterDetails.itemId
                            )}

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.itemId}
                        /> */}
                    </div>
                    <div className="input-grp w-full" >
                        <label>Start Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>Ending Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.endingDate ? "errorInput" : ""}`}
                            type="date"
                            id="endingDate"
                            name="endingDate"
                            autoComplete='off'
                            value={this.state.filterDetails.endingDate}
                            onChange={(event) => this.handleChange(event, "endingDate")}
                            style={{ width: "100%" }}
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endingDate}
                        /> */}
                    </div>
                    <div className="search-grp w-full">
                        <label>Search</label>
                        <select
                            name="search"
                            className="w-full"
                            value={this.state.filterDetails.search}
                            onChange={(event) =>
                                this.handleDropdownChange(
                                    event,
                                    "search",
                                    "filterDetails"
                                )
                            }
                        >

                            {this.state.searchList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.search}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="btn-grp mt-3">
                    <button
                        class="add-btn"
                        onClick={() => this.getAllReports()}
                        disabled={this.state.isLoading}
                    >
                        {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Search"}
                    </button>
                    <button className="cancel-btn" onClick={this.resetForm} disabled={this.state.isLoading}>Cancel</button>

                    {this.state.stockLedgerReportList.length > 0 && this.state.filterDetails.search === 'stockRegister' ?
                        <button
                            class="print-btn"
                            onClick={() => printFunction()}
                            disabled={this.state.isLoading}
                        >
                            Print
                        </button>
                        : null}

                </div>
                {this.state.filterDetails.search === "stockRegister" && this.state.stockLedgerReportList.length > 0 ?
                    (<div className="item-grp flex gap-2.5 mt-2.5 w-[60%]">
                        {this.state.filterDetails.searchBy === "partyName" ?
                            (<div className="input-grp w-[60%]">
                                <label>Party Name</label>
                                <MultiSelectDropdown
                                    drpIdentity="partyId"
                                    options={this.state.partyDropdownList}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={(selected) =>
                                        this.setFilterParameters(selected, "partyId")
                                    }
                                    allowSelectAll={false}
                                    value={this.state.partyDropdownList.filter(
                                        (party) =>
                                            party.value === this.state.filterDetails.partyId
                                    )}

                                />
                            </div>) : this.state.filterDetails.searchBy === "batchNo" ?
                                (<div className="input-grp w-[60%]">
                                    <label>Batch No.</label>
                                    <MultiSelectDropdown
                                        drpIdentity="batchNo"
                                        options={this.state.partyDropdownList}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "batchNo")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.batchDropdownList.filter(
                                            (party) =>
                                                party.value === this.state.filterDetails.batchNo
                                        )}

                                    />
                                </div>)
                                : this.state.filterDetails.searchBy === "allTransaction" ?
                                    (<div className="input-grp w-[60%]">
                                        <label>All Transaction</label>
                                        <MultiSelectDropdown
                                            drpIdentity="allTransaction"
                                            options={this.state.allTransactionDropdownList}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={(selected) =>
                                                this.setFilterParameters(selected, "allTransaction")
                                            }
                                            allowSelectAll={false}
                                            value={this.state.allTransactionDropdownList.filter(
                                                (party) =>
                                                    party.value === this.state.filterDetails.allTransaction
                                            )}

                                        />
                                    </div>) : null}
                        <div className="search-grp w-[40%]">
                            <label>Search By</label>
                            <select
                                name="searchBy"
                                className="w-full"
                                value={this.state.filterDetails.searchBy}
                                onChange={(event) =>
                                    this.handleDropdownChange(
                                        event,
                                        "searchBy",
                                        "filterDetails"
                                    )
                                }
                            >
                                {this.state.searchByList.map((x, key) => (
                                    <option key={key} value={x.value}>
                                        {x.search}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>) : null
                }

                {this.state.filterDetails.search === "stockRegister" ? (
                    <div class="item-listing mt-3">
                        <div className="hidden print-title">
                            <h4 className="text-black font-semibold text-[18px]">Stock Ledger</h4>
                        </div>
                        <div class="itemList-table">
                            <div class="table-container" style={{ height: "calc(100vh - 450px)" }} >
                                <table class="itemList">
                                    <thead>
                                        <tr>
                                            <td style={{ width: "12%" }} className='w-[12%]'>Ref No.</td>
                                            <td style={{ width: "12%" }} className='w-[12%]'>Date</td>
                                            <td style={{ width: "26%" }} className='w-[26%]'>Party Name</td>
                                            <td style={{ width: "14%" }} className='w-[14%]'>Batch No.</td>
                                            <td style={{ width: "12%" }} className='w-[12%]'>Receipt</td>
                                            <td style={{ width: "12%" }} className='w-[12%]'>Sales</td>
                                            <td style={{ width: "12%" }} className='w-[12%]'>Free</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.stockLedgerReportList && this.state.stockLedgerReportList.length > 0 ? (
                                            this.state.stockLedgerReportList.map((details, key) => (
                                                <tr
                                                    key={key}
                                                >
                                                    <td>{details.refNo}</td>
                                                    <td>{moment(details.refDate).format('DD MMM YYYY')}</td>
                                                    <td>{details.partyName}</td>
                                                    <td>{details.batchNo}</td>
                                                    <td>{details.produceedQty}</td>
                                                    <td>{details.issuedQty}</td>
                                                    <td>{details.isFreeQty}</td>
                                                </tr>
                                            ))
                                        ) : this.state.itemsForStockLedgerList && this.state.itemsForStockLedgerList.length === 0 && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.itemsForStockLedgerList && this.state.itemsForStockLedgerList.length === 0 && this.state.tableStatus === "" ? null : ""}
                                    </tbody>


                                </table>
                            </div>
                        </div>
                    </div>)
                    : (<div class="item-listing mt-3">
                        <div class="itemList-table">
                            <div class="table-container" style={{ height: "calc(100vh - 176px)" }} >
                                <table class="itemList">
                                    <thead>
                                        <tr>
                                            <td style={{ width: "15%" }}>Batch No.</td>
                                            <td style={{ width: "15%" }}>Mfg. Date</td>
                                            <td style={{ width: "15%" }}>Exp. Date</td>
                                            <td style={{ width: "14%" }}>MRP</td>
                                            <td style={{ width: "14%" }}>Stock</td>
                                            {/* <td style={{ width: "13%" }}>Rate</td>
                                            <td style={{ width: "14%" }}>Amount</td> */}
                                        </tr>
                                    </thead>


                                    <tbody>
                                        {this.state.stockLedgerReportBatchStock && this.state.stockLedgerReportBatchStock.length > 0 ? (
                                            this.state.stockLedgerReportBatchStock.map((details, key) => (
                                                <tr
                                                    key={key}
                                                >
                                                    <td>{details.batchNo}</td>
                                                    <td>{moment(details.mfgDate).format('DD MMM YYYY')}</td>
                                                    <td>{moment(details.expDate).format('DD MMM YYYY')}</td>
                                                    <td>{details.mrp}</td>
                                                    <td>{details.quantity}</td>
                                                </tr>
                                            ))
                                        ) : this.state.itemsForStockLedgerList && this.state.itemsForStockLedgerList.length === 0 && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.itemsForStockLedgerList && this.state.itemsForStockLedgerList.length === 0 && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>)}


                {this.state.filterDetails.search === "stockRegister" && this.state.stockLedgerReportList.length > 0 ?
                    <div className="item-sections  min-w-[250px] max-w-[300px]  rounded-[10px] !px-3 !py-5  !bg-white mt-[15px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                        <p className='!text-center !text-[17px] !font-semibold'>Summary</p>
                        <div className="search-grp flex gap-2">
                            <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                                Total Stock
                            </div>
                            <input
                                className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                type="number"
                                id="totalProduceedQty"
                                name="totalProduceedQty"
                                autocomplete="off"
                                disabled
                                value={this.state.totalProduceedQty}
                            />
                        </div>
                        <div className="search-grp flex gap-2">
                            <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                                Total Issue
                            </div>
                            <input
                                className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                                type="number"
                                id="totalIssuedQty"
                                name="totalIssuedQty"
                                autocomplete="off"
                                disabled
                                value={this.state.totalIssuedQty}
                            />
                        </div>
                        <div className="search-grp flex gap-2">
                            <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                                Closing Balance
                            </div>
                            <input
                                className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                                type="number"
                                id="closingBalance"
                                name="closingBalance"
                                autocomplete="off"
                                disabled
                                value={this.state.closingBalance}
                            />
                        </div>



                    </div>
                    : null
                }

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Near Expiry Report</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Months Remain: <strong>{this.state.filterDetails.days}</strong><br />
                                            Material Type: <strong>{this.state.filterDetails.materialType}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                      <div>
                                        <span className="info-label">Item Name:</span>
                                        <p className="info-value">Paracetamol</p>
                                      </div>
                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "35%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Ref No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Date
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Party Name
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Batch No
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Receipt
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Sales
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Free
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.stockLedgerReportList && this.state.stockLedgerReportList.length > 0 ?
                                    this.state.stockLedgerReportList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.refNo}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {moment(details.refDate).format('DD MMM YYYY')}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.partyName}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.batchNo}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.produceedQty}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.issuedQty}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.isFreeQty}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default StockLedgerReport;